import React from 'react'
import { motion } from 'framer-motion'
import './About.css'

const About = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.2
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  }

  const highlights = [
    {
      icon: '🚀',
      title: 'Performance Focused',
      description: 'Building fast, optimized applications that deliver exceptional user experiences.'
    },
    {
      icon: '💡',
      title: 'Problem Solver',
      description: 'Turning complex challenges into elegant, scalable solutions.'
    },
    {
      icon: '🎨',
      title: 'Design Minded',
      description: 'Creating beautiful interfaces with attention to detail and user experience.'
    },
    {
      icon: '🔧',
      title: 'Full Stack Expertise',
      description: 'Proficient in both frontend and backend technologies for complete solutions.'
    }
  ]

  return (
    <section id="about" className="about section">
      <div className="container">
        <motion.div
          className="about-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.div className="about-header" variants={itemVariants}>
            <span className="section-label">About Me</span>
            <h2 className="section-title">
              Crafting Digital Experiences with <span className="text-gradient">Passion</span>
            </h2>
            <p className="section-subtitle">
              I'm a Full Stack Developer based in Nigeria, specializing in building exceptional digital experiences
              that combine beautiful design with robust functionality.
            </p>
          </motion.div>

          <div className="about-grid">
            <motion.div className="about-text" variants={itemVariants}>
              <p>
                With over 3 years of experience in web development, I've had the privilege of working with
                diverse clients and projects, from educational institutions to innovative startups. My journey
                in tech started with a curiosity for how things work on the web, and it has evolved into a
                passion for creating meaningful digital solutions.
              </p>
              <p>
                I specialize in the MERN stack (MongoDB, Express.js, React.js, Node.js) and have extensive
                experience with modern frameworks like Next.js. My approach combines technical expertise with
                a keen eye for design, ensuring that every project I work on is not only functional but also
                visually stunning and user-friendly.
              </p>
              <p>
                When I'm not coding, you'll find me exploring new technologies, contributing to open-source
                projects, or sharing knowledge with the developer community. I believe in continuous learning
                and staying updated with the latest industry trends.
              </p>

              <div className="about-cta">
                <a href="#contact" className="btn btn-primary">
                  <span>Let's Work Together</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </a>
                <a href="/cv.pdf" className="btn btn-secondary" download>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/>
                  </svg>
                  <span>Download CV</span>
                </a>
              </div>
            </motion.div>

            <motion.div className="about-highlights" variants={itemVariants}>
              {highlights.map((highlight, index) => (
                <motion.div
                  key={index}
                  className="highlight-card glass-card"
                  variants={itemVariants}
                  whileHover={{ y: -5, scale: 1.02 }}
                >
                  <span className="highlight-icon">{highlight.icon}</span>
                  <h3 className="highlight-title">{highlight.title}</h3>
                  <p className="highlight-description">{highlight.description}</p>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default About
